import { render, staticRenderFns } from "./EModalDuplicarAulaPolivalencia.vue?vue&type=template&id=5c785165&scoped=true"
import script from "./EModalDuplicarAulaPolivalencia.vue?vue&type=script&lang=js"
export * from "./EModalDuplicarAulaPolivalencia.vue?vue&type=script&lang=js"
import style0 from "./EModalDuplicarAulaPolivalencia.vue?vue&type=style&index=0&id=5c785165&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c785165",
  null
  
)

export default component.exports